import injectStores from '../RootStore/injectStores';

import React from 'react';

interface FlexColumnProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

class FlexColumn extends React.PureComponent<FlexColumnProps> {
  render() {
    const { children, style, ...rest } = this.props;
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', ...style }}
        {...rest}
      >
        {children}
      </div>
    );
  }
}

export default injectStores(FlexColumn);
